
export default defineNuxtPlugin(() => {
  const { $api, $dialogs } = useNuxtApp();
  const gamification = reactive({
    challengeStep: {},
    async handleChallengePopInfo(id: number) {
      try {
        const res = await $api.endPoints.getStructure(
          `fragments_get-challenge-by-id`,
          {
            id,
          },
        );
        const challengeItem = Array.isArray(res) && res[0]?.data;
        if (challengeItem) {
          $dialogs.openJoinChellengePop(challengeItem);
        }
      } catch (error) {
        console.error("error in handleChallengePopInfo");
      }
    },
    ticketAmount(item:any) {
      const challengeStep =
        item?.chained && item?.challengeSteps
          ? item?.challengeSteps[item?.challengeSteps?.length - 1]
          : item?.challengeSteps[0];
      return (gamification.challengeStep =
        challengeStep?.rewards?.find(
          (reward: any) => reward?.currency == 'TICKETS'
        ).amount || null);
    }
  });
  return {
    provide: { gamification },
  };
});
